import { faCheckCircle, faClock, faExclamation, faWallet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toolbar from "components/Toolbar";
import AuthContext from "context/AuthContext";
import dayjs from "dayjs";
import { Button } from "flowbite-react";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { apiGet } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function MyWallet() {
  const { t } = useTranslation();
  let { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [balance, setBalance] = useState(null);
  const [page, setPage] = useState(1);
  const [transactions, setTransactions] = useState([]);

  const getWalletBalance = async () => {
    try {
      var response = await apiGet(pathObj.getBalance);
      if (response.data.success) {
        setBalance(response.data.results.wallet_amount);
      }
    } catch (err) {}
  };

  useEffect(() => {
    getWalletBalance();
  }, []);

  useEffect(() => {
    const getTransactions = async (page) => {
      try {
        const payload = {
          page,
        };
        var response = await apiGet(pathObj.walletStatement, payload);
        setTransactions([...transactions, ...response.data.results.docs]);
        if (page < 5 && response.data.results.hasNextPage) {
          setPage((prev) => prev + 1);
        }
      } catch (err) {}
    };
    getTransactions(page);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <>
      <Toolbar title={t("O_MY_WALLET")} showBackBtn={true} />
      <div className="flex flex-col w-full justify-center items-center">
        <div className="w-full md:w-[25rem] mt-3 p-4 overflow-y-auto">
          {balance && (
            <div className="bg-card mx-1 text-white p-[1rem] cursor-pointer text-center">
              <div className="font-medium my-4 ms-1">{t("BALANCE")}</div>
              <div className="font-bold text-2xl ms-1 mb-4">
                {user.wallet_currency} {balance}
              </div>
            </div>
          )}
        </div>

        <Link to={"/wallet-window"}>
          <Button className="bg-primary py-3 px-10 rounded-xl flex gap-2 items-center w-full">
            <FontAwesomeIcon icon={faWallet} className="text-white" size={"lg"} />
            <span className="text-base font-medium text-white">{t("WALLET_WINDOW")}</span>
          </Button>
        </Link>

        <div className="px-4 w-full my-4">
          <div className="flex justify-between w-full my-5 px-2">
            <div className="text-lg font-medium">{t("O_WALLET_STATEMENT")}</div>
            <Link to={"/gift-cards/history"} className="text-lg font-medium text-primary">
              {t("O_ALL")}
            </Link>
          </div>

          {transactions.map((it) => (
            <div
              key={it._id}
              className="bg-card text-white p-4 flex justify-between items-center gap-3 mt-3 cursor-pointer"
              onClick={() => {
                navigate(`/transaction-details/${it._id}`);
              }}
            >
              <div className="flex justify-start items-center gap-2">
                <div className="relative">
                  <img src={it.senderData?.profile_pic || it.receiverData?.profile_pic || null} className="rounded-full h-[3rem] w-[3rem]" alt="" />
                  {it.status === "completed" && <FontAwesomeIcon icon={faCheckCircle} className="absolute right-[-0.2rem] bottom-[-0.2rem] text-green-700" size={"lg"} />}
                  {it.status === "pending" && <FontAwesomeIcon icon={faClock} className="absolute right-[-0.2rem] bottom-[-0.2rem] text-yellow-700" size={"lg"} />}
                  {it.status === "failed" && <FontAwesomeIcon icon={faExclamation} className="absolute right-[-0.2rem] bottom-[-0.2rem] text-red-700" size={"lg"} />}
                </div>
                <div>
                  <span className="text-lg font-medium">{it.senderData?.name || it.receiverData?.name}</span>
                  <div className="flex flex-col">
                    <span className="font-medium">{it.transaction_type}</span>
                    <span className="font-medium">{dayjs(it.created_at).format("DD-MM-YYYY hh:mm A")}</span>
                  </div>
                </div>
              </div>
              <span className={`text-lg font-medium ${it.type === "credit" ? "text-green-700" : ""}`}>
                {it.type === "debit" ? "-" : "+"}
                {it.transaction_amount}
                {it.transaction_currency}
              </span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default MyWallet;
